<template>
  <div>
    <v-dialog
      :model-value="showModal"
      @update:modelValue="handleDialogUpdate"
      content-class="show-modal-popup"
      color="primary"
      :scrim="'#212121'"
      :opacity="0.65"
      persistent
      scrollable
    >
      <v-card class="show-modal-popup show-modal-popup__card">
        <v-card-title class="pa-5 pb-0 flex-column v-header--fixed">
          <div class="d-flex justify-end" style="width: 100%">
            <v-btn icon variant="text" @click="$emit('hide-modal')">
              <icon height="14" width="14">close-x</icon>
            </v-btn>
          </div>
          <div class="show-modal-popup__icon text-center">
            <icon
              class="mb-5 mt-n4"
              fill="rgb(var(--v-theme-primary))"
              height="54"
              width="54"
            >
              Check-Mark-Circle
            </icon>
          </div>
          <h4 class="text-center">
            Your Pickup Is Completed!
          </h4>
        </v-card-title>
        <v-card-actions class="pa-5 flex-column">
          <v-btn
            color="primary"
            class="show-modal-popup__btn"
            rounded
            size="large"
            variant="flat"
            width="100%"
            @click="$emit('hide-modal')"
          >
            Done
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: 'OrderComplete',
  props: {
    showModal: {
      type: Boolean,
      default: () => false
    }
  },
  methods: {
    handleDialogUpdate(value) {
      if (!value) this.$emit('hide-modal');
    }
  }
};
</script>

<style lang="scss" scoped>
.v-btn--icon.v-btn--density-default {
    width: 32px;
    height: 32px;
}

.v-dialog {
  width: min(100dvw - 2rem, var(--project-max-width) - 2rem);
  width: 100%;
}

.show-modal-popup {  
  &__card {
    display: flex;
    flex-direction: column;
    max-width: min(100dvw - 2rem, var(--project-max-width) - 2rem);
    max-height: 94%;
    margin: 0;
    overflow: hidden;
    border-radius: 2rem !important;
  }

  h4 {
      font-size: 1.125rem !important;
      line-height: 1.375rem !important;
  }
}

:deep(.v-overlay__content) {
  display: flex;
  flex-direction: column;
  max-height: calc(100vh - 31px);
  max-width: min(480px, calc(100vw - 48px));
}
</style>